<template>
	<div>
		<div class="card">
			<div class="card__header">
				<h4 class="card__title">Контакты</h4>
			</div>
			<div class="card__body">
				<div class="contacts">
					<a href="https://t.me/welwin_helping" class="contacts__item" target="_blank">
						<img class="contacts__item-photo" :src="'/images/tg_welwin.jpg'" alt="">
						<span class="contacts__item-title">Welwin Техподдержка</span>
						<span class="contacts__item-link">t.me/welwin_helping</span>
						<span class="contacts__item-description">✅️Техподдержка сайта Welwin Casino<br>Отвечаем
							ежедневно 10:00-23:00 Мск</span>
						<a class="contacts__item-btn btn btn--primary" href="https://t.me/welwin_helping">Отправить
							сообщение</a>
					</a>
					<a href="https://t.me/avocado_partners" class="contacts__item" target="_blank">
						<img class="contacts__item-photo" :src="'/images/tg_avatar.jpg'" alt="">
						<span class="contacts__item-title">Avocado Partners</span>
						<span class="contacts__item-link">t.me/avocado_partners</span>
						<span class="contacts__item-description">✅️Менеджер проектов Avocado Casinos<br>Наши сайты: <a
								href="https://t.me/avocado_projects">@avocado_projects</a></span>
						<a class="contacts__item-btn btn btn--primary" href="https://t.me/avocado_partners">Отправить
							сообщение</a>
					</a>
					<a href="https://vk.com/welwin_casino" class="contacts__item" target="_blank">
						<img class="contacts__item-photo" :src="'/images/tg_welwin.jpg'" alt="">
						<span class="contacts__item-title">WELWIN CASINO | ВКОНТАКТЕ</span>
						<span class="contacts__item-link">vk.com/welwin_casino</span>
						<span class="contacts__item-description">✅️Официальная группа Вконтакте<br>❗️Ежедневно выдаём
							промокоды</span>
						<a class="contacts__item-btn btn btn--primary" href="https://vk.com/welwin_casino">Перейти в
							сообщество</a>
					</a>
					<a href="https://t.me/welwin_kazino" class="contacts__item" target="_blank">
						<img class="contacts__item-photo" :src="'/images/tg_welwin.jpg'" alt="">
						<span class="contacts__item-title">WELWIN CASINO | TELEGRAM</span>
						<span class="contacts__item-link">t.me/welwin_kazino</span>
						<span class="contacts__item-description">✅️Официальный канал Telegram<br>❗️Ежедневно выдаём
							промокоды</span>
						<a class="contacts__item-btn btn btn--primary" href="https://t.me/welwin_kazino">Перейти на
							канал</a>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>